// extracted by mini-css-extract-plugin
export default {"menuSection":"menuSection---LMZXf","menuSection__label":"menuSection__label---rEIwd"};